import React from "react";
import Select from "react-select";
import "./dropdown.css";

const DropDown = ({
  options,
  value,
  onChange,
  loading,
  placeholder,
  isSearchable = true,
  maxMenuHeight = 200,
  isDisabled = false,
  isClearable = true,
}) => {  return (
    <div className="dropDownWrapper">
      {options && options.length > 0 && !value && (
        <div className="options-count">{options.length}</div>
      )}      
      <Select
        options={options}
        value={value}
        onChange={onChange}
        isDisabled={loading}
        isClearable={isClearable}
        className="react-select-container"
        classNamePrefix="react-select"
        placeholder={placeholder}
        isSearchable={isSearchable}
        maxMenuHeight={maxMenuHeight}
      />
    </div>
  );
};

export default DropDown;